import { useTranslation } from '@/i18n';
import { Checkbox, Toggle } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC } from 'react';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

type ModelTrainingSettingProps = {
  isAllowed: boolean;
  isInitial: boolean;
  onChange: (isAllowed: boolean) => void;
};

export const ModelTrainingSetting: FC<ModelTrainingSettingProps> = ({
  isAllowed,
  isInitial = false,
  onChange,
}) => {
  const { t } = useTranslation();
  const toggleId = 'model-training-toggle';

  return (
    <div className={cx('container')}>
      <p>{t('ai_service_setting.model_training.description')}</p>
      {isInitial ? (
        <>
          <p>{t('ai_service_setting.model_training.changeable')}</p>
          <Checkbox
            label={t('ai_service_setting.model_training.allow_label')}
            checked={isAllowed}
            onChange={(e) => onChange(e.target.checked)}
          />
        </>
      ) : (
        <div className={cx('modelTrainingToggleRow')}>
          <Toggle
            id={toggleId}
            checked={isAllowed}
            onChange={(e) => onChange(e.target.checked)}
          />
          <label htmlFor={toggleId}>
            {t('ai_service_setting.model_training.allow_label')}
          </label>
        </div>
      )}
    </div>
  );
};
